export const SUITE_STATES = Object.freeze({
    started: 'started',
    created: 'created',
    opened: 'opened',
    closed: 'closed'
});
